
import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
//
import PaymentsAndUpdates from './../../mixins/payments_and_updates.js'; //  PaymentsAndUpdates == Resources
import Preset from './../../mixins/preset.js'; //preset
import CNpaymentModal from './../../templates/CNpaymentModal/index.vue' //payent modal
import CNpaymentModalProcess from './../../templates/CNpaymentModal/script.js' //payent modal

let service = new services();

export default {
name: 'CNPayments',
mixins: [Preset, CNpaymentModalProcess],//,PaymentAndUpdate],
data () {
    return {
        user:{},
        payment:{},
        set_payment_data:{},
        set_payment_object:{},
        payment_details_data:{},
        component_view:{},
        amount_topay:0,

        //
        disable_btn: false,
        current_wallet_balance: 0,
        loggedIn: false,
        //
        payment_message:'',
        service_payment_ref: '',
        token_key:0,
        data_plan_payment_data: {},
        show_done: false,
    }
},
components: {
    'second-header': SecondHeader,
    'main-footer': MainFooter,
    "cnpayment-modal": CNpaymentModal
},
computed: {},
methods: {
    //settings
    setComponentView(view,attr1,attr2){
        this.component_view = {};
        this.component_view[view] = true;
        this.jumpToView('topp02');
    },

    getIncomingRequest(){
        //get route params
        if((this.$route.query.pay) && (this.$route.query.pay > 0)){
            this.pay_type = this.$route.query.pay;
        }
        if((this.$route.query.re) && (this.$route.query.re != '')){
            this.service_payment_ref = this.$route.query.re;
        }
        // if((this.$route.query.no) && (this.$route.query.no != '')){
        //     this.token_key = this.$route.query.no;
        //     this.setPreset();
        // }
        //
        this.setPayment();
    },

    setPayment(){
        if(this.pay_type > 0){ 
            //get the payment details
            var payload = {
                pay_service_type: 3, //insurance
                pay_service_ref: this.service_payment_ref,
                pay_service_user_token: this.token_key,
            }
            service.setPaymentRequests(this, payload).then(data => {
                if(data.body.status == 200) {
                    //set payment data
                    if(data.body.data_pay_status == 1){
                        //payment pending //prompt payment
                        this.payment_details_data = data.body.data_payment_data;
                        this.setComponentView('paymentDetails','','');
                    }else{
                        console.log(data.body.data_pay_status);
                    }
                }else{
                    this.payment_message = "Sorry, could not find payment details.";
                }
            }).catch((err) => { })
        }
    },


    setPaymentModeModal(payment_data){
        this.set_payment_data = payment_data;
        this.set_payment_data.callback_url = "account";
        if((this.set_payment_data.total_amount) && (this.set_payment_data.total_amount > 0)){
            this.paymentModalComponentKey++;
            setTimeout(function (){
                $('#paywith').modal();
            }, 10);
        }else{
            this.data_processing_message = "Sorry could not fully submit form, please check your entry, or contact us";
        }  
    },

    setPaymentDetails(){
        this.set_payment_object = {
            payment_detail_type: 'insuremoto',
            payment_detail_name: "Insuremoto Payments",
            payment_detail_logo: "",
            payment_detail_set_callbackurl: 'insuremoto', //sets
        }
    },

    //wallet calls
    getWalletTransactions() {
        let user_id = this.token_key;
        service.getWalletTransactions(this,user_id).then(data => {
            if(data.body.status == 200) {
                this.current_wallet_balance = data.body.data_current_wallet_balance;
            }
         }).catch((err) => {
            if(err) {
                toastr.error('Sorry, could not process information', 'Warning!');
            }
         })
    },

    formatCurrency(currency){
        currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
        return currency.replace("NGN", ""); //strip off NGN
    },

    //....wallet calls

    //preps
    setPreset(){
        service.authTokenKey(this, this.token_key).then(data => {
            if(data.body.status == 200) {
                //set token
                let self = this;
                localStorage.setItem("cityneeds_token",data.body.data_key);
                localStorage.setItem("cityneeds_token_key", this.token_key);
                setTimeout(function (){
                    self.preset();
                    setTimeout(function (){
                        self.xreset();
                    }, 10);
                }, 10);
            }else{
                this.payment_message = "Sorry, could not find payment details.";
            }
        }).catch((err) => { })
    },
},


created: function(){
    this.getIncomingRequest();
    this.setPaymentDetails();
    this.getWalletTransactions();
    // if(localStorage.getItem("cityneeds_user") != null) {
    //     this.preset();
    // }
    //temp
    this.payment.title = "Insuremoto Payments"
}

}


// WEBPACK FOOTER //
// ./src/components/CNPayments/script.js